(function() {
	'use strict';
	var $ = avm.require('cash'),
		$tabPanels = $('a.nav-link');

	$tabPanels.on('click', function () {
		$tabPanels.removeClass('active');
		$(this).addClass('active')
	})


})();
